export function applyStylesToElement(
  element: HTMLElement,
  styles: CSSStyleDeclaration
): void {
  for (const prop in styles) {
    // skip cssText as it will set the font size to null
    // skip readonly properties
    if (
      prop !== 'cssText' &&
      Object.getOwnPropertyDescriptor(element.style, prop)?.writable
    ) {
      element.style[prop] = styles[prop];
    }
  }
}

export function getWidthFromCopy(element: HTMLElement): number {
  // The copy is needed as the the width can't be computed directly from
  // the initial element in all cases (issues appear when the grid is hidden
  // or the grid options are computed later to display the button)
  const elementCopy = element.cloneNode(true) as HTMLElement;

  // the styles are applied in a CSS class not globally available
  // so we need to add the styles manually to get the same width
  applyStylesToElement(elementCopy, getComputedStyle(element));

  // add copy to the body
  document.body.append(elementCopy);

  // Label width is the width of the button text in px
  const elementWidth = elementCopy.getBoundingClientRect().width;

  // remove the copy from DOM after the width was computed
  elementCopy.remove();

  return elementWidth;
}
